import React from "react";
import { Link, useLocation } from "react-router-dom";
import { PageShell, SectionLabel, SlideCorner } from "@/components/Layout";
import { Ticket, Briefcase, Package, ListChecks, ArrowRight } from "lucide-react";

const TYPES = [
  { k: "tickets", label: "Sell Tickets", icon: Ticket, blurb: "Gigs, screenings, workshops, salons. List an event, set your ticket tiers, get paid." },
  { k: "service", label: "List a Service", icon: Briefcase, blurb: "Mixing, mastering, photography, editing, mentoring. List what you do, set your rate." },
  { k: "product", label: "Sell a Digital Product", icon: Package, blurb: "Presets, samples, scripts, lookbooks, lessons. Upload once, sell forever." },
  { k: "mine", label: "My Listings", icon: ListChecks, blurb: "Manage everything you've published. Pause, edit, archive." },
];

export default function Create() {
  const location = useLocation();
  const active = location.pathname.split("/").pop();
  const current = TYPES.find((t) => t.k === active) || TYPES[0];

  return (
    <PageShell>
      <section className="relative grid-bg border-b border-border">
        <SlideCorner right="CREATE" />
        <div className="max-w-[1600px] mx-auto px-5 md:px-10 pt-16 pb-12">
          <SectionLabel>Create</SectionLabel>
          <h1 className="font-display text-4xl md:text-6xl font-bold leading-[0.95] tracking-tighter">{current.label}.</h1>
          <p className="mt-6 max-w-2xl text-white/80">{current.blurb}</p>
        </div>
      </section>

      <section className="border-b border-border bg-[#0c0c0e]">
        <div className="max-w-[1600px] mx-auto px-5 md:px-10 py-6 flex gap-2 flex-wrap">
          {TYPES.map((t) => (
            <Link key={t.k} to={`/create/${t.k}`} data-testid={`create-tab-${t.k}`} className={`btn-pill ${active === t.k ? "btn-coral" : ""}`}>
              <t.icon size={13} /> {t.label}
            </Link>
          ))}
        </div>
      </section>

      <section>
        <div className="max-w-[1100px] mx-auto px-5 md:px-10 py-20">
          <div className="border border-dashed border-border p-14 text-center">
            <p className="font-display text-3xl md:text-5xl font-bold leading-tight">Coming soon.</p>
            <p className="meta-mono mt-5 !text-white/55">— THIS BUILDER IS NEXT IN THE BUILD QUEUE</p>
            <Link to="/dashboard" className="btn-pill mt-8 inline-flex">Back to dashboard <ArrowRight size={14} /></Link>
          </div>
        </div>
      </section>
    </PageShell>
  );
}
